import { render, staticRenderFns } from "./QuoteSettings.vue?vue&type=template&id=c0e225d8&"
import script from "./QuoteSettings.vue?vue&type=script&lang=js&"
export * from "./QuoteSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports